module.exports = __webpack_public_path__ + "static/media/starry-night--big.e90617c9.png";